import React from "react";
import "./style.css";

// images
import img1 from "../../assets/images/Destop-wallpaper.webp";
// branding
import branding0 from "../../assets/images/GD/branding0.webp";
import branding1 from "../../assets/images/GD/branding1.webp";
import branding2 from "../../assets/images/GD/branding2.webp";
import branding3 from "../../assets/images/GD/branding3.webp";
import branding4 from "../../assets/images/GD/branding4.webp";
import branding5 from "../../assets/images/GD/branding5.webp";
import branding6 from "../../assets/images/GD/branding6.webp";
import branding7 from "../../assets/images/GD/branding7.webp";
// flyers
import flyers0 from "../../assets/images/Flyers/flyer0.webp";
import flyers1 from "../../assets/images/Flyers/flyer1.webp";
import flyers2 from "../../assets/images/Flyers/flyer2.webp";
//cover art
import coverArt0 from "../../assets/images/cover-art/cover0.webp";
// name cards
import nameCard0 from "../../assets/images/name-cards/Alpha.webp";
import nameCard1 from "../../assets/images/name-cards/Buhle.webp";
import nameCard2 from "../../assets/images/name-cards/Kans.webp";
import nameCard3 from "../../assets/images/name-cards/Khaeda.webp";
import nameCard4 from "../../assets/images/name-cards/Mad Lion.webp";
import nameCard5 from "../../assets/images/name-cards/Motheo.webp";
import nameCard6 from "../../assets/images/name-cards/Pot3nt.webp";
import nameCard7 from "../../assets/images/name-cards/Silas.webp";
import nameCard8 from "../../assets/images/name-cards/Sir Scotty.webp";
import nameCard9 from "../../assets/images/name-cards/W X Y N.webp";
import nameCard10 from "../../assets/images/name-cards/WayneII.webp";
import nameCard11 from "../../assets/images/name-cards/minnie.webp";

import Navigation from "../../components/Navigation";
import { Helmet } from "react-helmet-async";

const portfolioItemsBranding = [
	{
		id: 0,
		image: branding0,
		description: "",
	},
	{
		id: 1,
		image: branding1,
		description: "",
	},
	{
		id: 2,
		image: branding2,
		description: "",
	},
	{
		id: 3,
		image: branding3,
		description: "",
	},
	{
		id: 4,
		image: branding4,
		description: "",
	},
	{
		id: 5,
		image: branding5,
		description: "",
	},
	{
		id: 6,
		image: branding6,
		description: "",
	},
	{
		id: 7,
		image: branding7,
		description: "",
	},
];

const portfolioItemsFlyers = [
	{
		id: 1,
		image: flyers0,
		description: "",
	},
	{
		id: 2,
		image: flyers1,
		description: "",
	},
	{
		id: 3,
		image: flyers2,
		description: "",
	},
	
];

const portfolioItemsCoverArt = [
	{
		id: 1,
		image: coverArt0,
		description: "",
	},
	
];

const portfolioItemsNameCards = [
	{
		id: 0,
		image: nameCard0,
	},
	{
		id: 1,
		image: nameCard1,
	},
	{
		id: 2,
		image: nameCard2,
	},
	{
		id: 3,
		image: nameCard3,
	},
	{
		id: 4,
		image: nameCard4,
	},
	{
		id: 5,
		image: nameCard5,
	},
	{
		id: 6,
		image: nameCard6,
	},
	{
		id: 7,
		image: nameCard7,
	},
	{
		id: 8,
		image: nameCard8,
    },
    {
        id: 9,
        image: nameCard9
    },
    {
        id: 10,
        image: nameCard10
    },
    {
        id: 11,
        image: nameCard11
    }
];

const GraphicDesign = () => {
	return (
		<div className="collection-container">
			{/* <Sidebar currentPage="/collection" /> */}

			<main className="collection-main">
				<Navigation />
				<Helmet>
					<title>Graphic Design Portfolio | Big Cat Graphics</title>
					<meta
						name="description"
						content="A showcase of my graphic design projects, demonstrating creativity and technical skills in digital art."
					/>
				</Helmet>
				<div className="threeD-header" style={{backgroundImage: `url(${img1})`}}>
					<h1 className="threeD-title">Graphic Design Portfolio</h1>
					<p className="threeD-subtitle">
						A showcase of my graphic design projects, demonstrating creativity and technical skills in
						digital art.
					</p>
				</div>

				{/* Portfolio Grid */}
				<section className="threeD-wrapper">
					<h1 className="threeD-title" >Branding</h1>
					<div className="threeD-grid">
						{portfolioItemsBranding.map((item) => (
							<div key={item.id} className="threeD-item">
								<img
									src={item.image}
									alt={`${item.title} - ${item.category}`}
									className="threeD-image"
								/>
								<div className="threeD-overlay">
									<div className="threeD-text">
										<h3>{item.title}</h3>
										<p>{item.category}</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>

				<section className="threeD-wrapper">
					<h1 className="threeD-title" >Flyers</h1>
					<div className="threeD-grid">
						{portfolioItemsFlyers.map((item) => (
							<div key={item.id} className="threeD-item">
								<img
									src={item.image}
									alt={`${item.title} - ${item.category}`}
									className="threeD-image"
								/>
								<div className="threeD-overlay">
									<div className="threeD-text">
										<h3>{item.title}</h3>
										<p>{item.category}</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>

				<section className="threeD-wrapper">
					<h1 className="threeD-title" >Cover Art</h1>
					<div className="threeD-grid">
						{portfolioItemsCoverArt.map((item) => (
							<div key={item.id} className="threeD-item">
								<img
									src={item.image}
									alt={`${item.title} - ${item.category}`}
									className="threeD-image"
								/>
								<div className="threeD-overlay">
									<div className="threeD-text">
										<h3>{item.title}</h3>
										<p>{item.category}</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>

				<section className="threeD-wrapper">
					<h1 className="threeD-title" >Name Cards</h1>
					<div className="threeD-grid">
						{portfolioItemsNameCards.map((item) => (
							<div key={item.id} className="threeD-item">
								<img
									src={item.image}
									alt={`${item.title} - ${item.category}`}
									className="threeD-image"
								/>
								<div className="threeD-overlay">
									<div className="threeD-text">
										<h3>{item.title}</h3>
										<p>{item.category}</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>
			</main>
		</div>
	);
};

export default GraphicDesign;